<!-- HEADER CONTENEDOR -->
<app-header-core *ngIf="datesCompany != undefined" [dataCompany]="datesCompany"></app-header-core>

<!-- BARRA BUSQUEDA CONTENEDOR -->
<app-search *ngIf="datesCompany != undefined" [listYearMonth]="datesCompany.listYearMonth" [dataCompany]="datesCompany" [childExample]="datesCompany.code" [colorMain]="datesCompany.mainColor" [colorSecundario]="colorSecundario" [cataloguePax]="datesCompany.listPassenger"
    [catalogueItinerary]="datesCompany.listDays">
</app-search>
<!-- FIN BARRA BUSQUEDA CONTENEDOR -->
<!-- FIN HEADER CONTENEDOR -->
<!-- BODY CONTENEDOR -->
<!--<div id="content"></div>-->
<!-- FIN BODY CONTENEDOR -->
<div id="footer">
    <!-- FOOTER CONTENEDOR -->
    <!-- BARRA BUSQUEDA PIE CONTENEDOR -->
    <app-search *ngIf="datesCompany != undefined" [childExample]="datesCompany.code" [dataCompany]="datesCompany" [listYearMonth]="datesCompany.listYearMonth" [cataloguePax]="datesCompany.listPassenger" [catalogueItinerary]="datesCompany.listDays" [colorMain]="datesCompany.mainColor"
        [colorSecundario]="colorSecundario"></app-search>
    <!-- FIN BARRA BUSQUEDA PIE CONTENEDOR -->
    <div class="container" *ngIf="this.datesCompany!=undefined " style="display: block" [ngStyle]="{ 'background-color': colorPie }">
        <!-- end main -->
        <!-- start post footer -->
        <div class="post-footer">
            <div class="wrap2 row" id="powered-footer">


                <p style="color: #ececec;" [ngClass]="isTooDark(colorPie) ? 'darkMode' : 'lightMode'">Copyright {{ todayDate }} ©
                    <a href="https://galavail.com/" target="_blank" [ngClass]="isTooDark(colorPie) ? 'darkMode' : 'lightMode'">Galavail.com</a> &nbsp;All Rights Reserved. &nbsp;&bull;&nbsp;
                    <a [ngClass]="isTooDark(colorPie) ? 'darkMode' : 'lightMode'" [href]="mailTo">{{ datesCompany != undefined ?
            datesCompany.infoEmail : '' }}</a>
                </p>
                <img src="assets/images/powered-by-galavail.svg" alt="powered-by" style="margin-bottom: 15px;" />
            </div>
        </div>
        <!-- end post footer -->
    </div>
    <!-- FIN FOOTER CONTENEDOR -->
</div>
